import React from 'react';

const ApiConfig = () => {
  const config = {
    baseURL: 'https://admin.sbcexam.com/'
  };

  return config.baseURL;
};

export default ApiConfig;
